var map = {
	"./classes.js": "a305",
	"./course.js": "064e",
	"./exam.js": "848f",
	"./goods.js": "8ae1",
	"./homework.js": "3636",
	"./index.js": "29e9",
	"./library.js": "f433",
	"./news.js": "f440",
	"./order.js": "750a",
	"./package.js": "d4ab",
	"./periods.js": "f2a3",
	"./test.js": "1849",
	"./vip.js": "6fc3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e356";